import React from "react";
import Login from "./components/Login";
import {Signup} from "./components/Signup";
import {ForgotPassword} from "./components/ForgotPassword";
import {ConfirmEmail} from "./components/ConfirmEmail";
import {ConfirmDevice} from "./components/ConfirmDevice";
import {SetPassword} from './components/SetPassword';
import ChooseApplication from "./components/ChooseApplication";
import ChooseApplicationSignUp from "./components/ChooseApplicationSignUp";

export const routes = [
  <Login key="login" path="login"/>,
  <Signup key="signup" path="signup"/>,
  <ChooseApplication key="chose-application-login" path="choose-application"/>,
  <ChooseApplicationSignUp key="chose-application-signup" path="choose-application-signup"/>,
  <ForgotPassword key="forgot-password" path="forgot-password"/>,
  <SetPassword key="new-password" path="new-password"/>,
  <SetPassword key="new-password" path="new-password/:token"/>,
  <ConfirmEmail key="confirm-email" path="confirm-email"/>,
  <ConfirmEmail key="confirm-email" path="confirm-email/:token"/>,
  <ConfirmDevice key="confirm-email" path="confirm-device"/>,
  <ConfirmDevice key="confirm-email" path="confirm-device/:token"/>,
];
